import * as React from "react";
import styled from "styled-components";

import { Text } from "src/library/components/Text/Text";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { Origin } from "src/modules/support/api/support.api";

interface IProps {
  origin: Origin;
}

/**
 * Generates the support ticket origin column styled
 */
const SupportTicketOriginStyled: React.FC<IProps> = ({ origin }) => {
  const noDataDisplay = (
    <Text>
      {" - "}
    </Text>
  );

  // set the icon key based on origin
  const iconKey = React.useMemo(() => {
    switch (origin) {
      case Origin.Phone:
        return Icons.PHONE;
      case Origin.Email:
        return Icons.EMAIL;
      case Origin.Customer:
        return Icons.PERSON;

      default:
        console.error("Invalid Origin");

        return;
    }
  }, [ origin ]);

  if (!origin && !iconKey) {
    return (
      <OriginWrapper>
        {noDataDisplay}
      </OriginWrapper>
    );
  }

  return (
    <OriginWrapper>

      {!origin && noDataDisplay}

      {origin && iconKey && (
        <Icon
          icon={iconKey}
          $fillColor="primaryDark"
          size={24}
        />
      )}

    </OriginWrapper>
  );
};

const OriginWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export default SupportTicketOriginStyled;
